let defaultImage = 'https://firebasestorage.googleapis.com/v0/b/skillgigs-p3.appspot.com/o/Rectangle%2017058-3.png?alt=media&token=06360068-b65d-4c70-aa9f-8fde1028d96d';



export {defaultImage};